import { State } from 'modules';

export const loadUserPending = (state: State) => state.user.loadUserPending;
export const loadUserError = (state: State) => state.user.loadUserError;
export const loadUsersPending = (state: State) => state.user.loadUsersPending;
export const loadBankPending = (state: State) => state.user.loadUserPending;
export const inviteUserPending = (state: State) => state.user.inviteUserPending;

export const user = (state: State) => state.user.user;

export const loadMoreUsersPending = (state: State) =>
  state.user.loadUserPending;

export const allUsersLoaded = (state: State) => state.user.allUsersLoaded;
export const userList = (state: State) => state.user.usersList;
export const userFilters = (state: State) => state.user.filters;
export const usersListLoaded = (state: State) => state.user.usersListLoaded;
export const changeUserPasswordPending = (state: State) =>
  state.user.changeUserPasswordPending;

export const userSettings = (state: State) => state.user.userSettings;
export const userSettingsLoaded = (state: State) =>
  state.user.userSettingsLoaded;
